import React, { useEffect, useRef, useState } from "react";

import { BsCardChecklist, BsArrowRightShort, BsClockFill, BsList, BsFillGrid3X3GapFill } from 'react-icons/bs';
import { FaShareSquare } from 'react-icons/fa';
import { MdTimerOff } from 'react-icons/md';
import { BiChevronDown } from 'react-icons/bi';
import Menu from '../Home/Menu';
import Footer from '../Home/Footer';
import Web3EthContract from "web3-eth-contract";

import './custom.css';
import { Section } from "./expandSection";
import { useWeb3React } from "@web3-react/core";
import SelectWalletModal from "../walletConnect/modal";
import StakeContract from '../getAbis/stake.json'
import TokenContract from '../getAbis/token.json'
import swal from "sweetalert";
import formatDateAndtime from "../formatDateAndTime";
import { providerURL } from "../walletConnect/utils";

const Staking = () => {
  // Wallet Connection
  const {
    account,
    active,
    library,
    connector
  } = useWeb3React();

  const [isOpen, setIsOpen] = useState(false)
  const onOpen = (e) => {
    setIsOpen(true)
  };
  const onClose = (e) => {
    setIsOpen(false)
  };
  // const [isActive, setIsActive] = useState(false);

  // const handleClick = event => {
  //   setIsActive(current => !current);
  // };
  const [refresh, setRefresh] = useState(false);
  const [pendingReward, setPendingReward] = useState(0);
  const [totalStaked, setTotalStaked] = useState(0)
  // const [balance, setBalance] = useState(0)
  const [totalStakedOverall, setTotalStakedOverall] = useState(0)
  const [minStaking, setMinStaking] = useState(0)
  const [lastStartTime, setLastStartTime] = useState(0)
  const [rewardPerToken, setRewardPerToken] = useState(0)
  const [averageRewardPerToken, setAverageRewardPerToken] = useState(0)

  useEffect(() => {
    getData()
    apiValue()
  }, [account, active, refresh]);

  const apiValue = async () => {
    //return await AxiosInstance.get(endPoint);
    // const resp = await fetch(`http://backend-trader-pro.yourprojecttest.com/api/24hrvolume?type=`, {
    // const resp = await fetch(`http://backend-trader-pro.yourprojecttest.com/tgc/api/24hrvolume`, {
    //   method: 'GET',
    //   // headers: {

    //   // }
    // });
    // console.log('resp=>', await resp.json());
    // const apiData = await resp.json()
    // setAverageRewardPerToken(apiData.volume)
    // return resp.json();

    fetch('http://backend-trader-pro.yourprojecttest.com/tgc/api/24hrvolume').then(async (response) => {
      if (response.ok) {
        // console.log(await response.json()); //first consume it in console.log
        let apiData = await response.json()
        setAverageRewardPerToken(apiData.volume)
        // return response.json(); //then consume it again, the error happens

      }
    })
  }

  const getData = async () => {
    const { ethereum } = window;
    if (active) {
      Web3EthContract.setProvider(library.provider);
    } else {
      let provider = providerURL()
      Web3EthContract.setProvider(provider);
    }
    const stake_contract = new Web3EthContract(StakeContract.abi, StakeContract.STAKE_ADDRESS);
    // const token_contract = new Web3EthContract(TokenContract.abi, TokenContract.TOKEN_ADDRESS);
    setMinStaking(await stake_contract.methods.minStakingToken().call() / 10 ** 18)
    let RPT = await stake_contract.methods.accTokenPerShareLastTxn().call() / 10 ** 18
    setRewardPerToken(RPT.toLocaleString())
    let totalStakedAll = await stake_contract.methods.totalStaked().call();
    setTotalStakedOverall((totalStakedAll / 10 ** 18).toLocaleString())

    // let apiData = await apiValue()
    // setAverageRewardPerToken(apiData.volume)

    if (active) {
      // setBalance(await token_contract.methods.balanceOf(account).call())
      setPendingReward(await stake_contract.methods.pendingReward(account).call() / 10 ** 18)
      let userInfo = await stake_contract.methods.mapUserInfo(account).call()
      setTotalStaked(userInfo.amount / 10 ** 18)
      if (userInfo[2] == 0) {
        setLastStartTime('00:00:00');
      } else {
        setLastStartTime(formatDateAndtime(new Date(userInfo[2] * 1000)));
      }
    }
  }
  const unstake = async () => {
    const { ethereum } = window;
    Web3EthContract.setProvider(ethereum);
    const stake_contract = new Web3EthContract(StakeContract.abi, StakeContract.STAKE_ADDRESS);

    await stake_contract.methods.withdraw().estimateGas({
      from: account
    }).then(async function (gasAmount) {
      await stake_contract.methods.withdraw().send({
        from: account
      }, function (error, tx) {
        if (error) {
          swal({
            title: "Error Found",
            text: error.message,
            icon: "error",
            showCancelButton: false,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        } else {
          swal({
            title: "Withdrawn Staked TGC Successfully",
            text: "Please wait for wallet confirmation.",
            icon: "success",
            showCancelButton: false,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        }
      });
      setRefresh(!refresh)
    }).catch(function (error) {
      if (error.message.includes('eth_estimateGas')) {
        swal({
          title: "Error Found",
          text: 'Insufficient Funds For Transaction',
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Close",
          closeOnConfirm: false
        });
      } else {
        swal({
          title: "Error Found",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonClass: "btn-danger",
          confirmButtonText: "Close",
          closeOnConfirm: false
        });
      }
    });
  }

  const harvest = async () => {
    const { ethereum } = window;
    Web3EthContract.setProvider(ethereum);
    const stake_contract = new Web3EthContract(StakeContract.abi, StakeContract.STAKE_ADDRESS);

    await stake_contract.methods.withdrawReward().estimateGas({
      from: account
    }).then(async function (gasAmount) {
      await stake_contract.methods.withdrawReward().send({
        from: account
      }, function (error, tx) {
        if (error) {
          swal({
            title: "Error Found",
            text: error.message,
            icon: "error",
            showCancelButton: false,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        } else {
          swal({
            title: "Harvested Reward Successfully",
            text: "Please wait for wallet confirmation.",
            icon: "success",
            showCancelButton: false,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        }
      });
      setRefresh(!refresh)
    }).catch(function (error) {
      if (error.message.includes('eth_estimateGas')) {
        swal({
          title: "Error Found",
          text: 'Insufficient Funds For Transaction',
          icon: "error",
          showCancelButton: false,

          confirmButtonText: "Close",
          closeOnConfirm: false
        });
      } else {
        swal({
          title: "Error Found",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonClass: "btn-danger",
          confirmButtonText: "Close",
          closeOnConfirm: false
        });
      }
    });
  }

  const updatePage = () => {
    setRefresh(!refresh)
  }

  return (
    <>
      <Menu />
      <section className="DAOSlider sliderSection" id="staking">
        <div className="container">
          <div className="slideIn">
            <div className="row align-items-center">
              <div className="col-sm-6">
                <div className="slideContent">
                  <h1>Stake & Earn The Grays</h1>
                  <p>Easily TGC Token For High APR, Low Risk. </p>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="small_boxes_slider">
                      <h4>Latest Reward Per Transaction</h4>
                      {/* <h4>Recent <span>The Grays</span> Profit</h4> */}
                      <h5>{rewardPerToken} TGC</h5>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="small_boxes_slider">
                      <h4>Average Reward Per Transaction</h4>
                      <h5>{averageRewardPerToken} TGC</h5>
                      {/* <h5>{avgTxReward} TGC</h5>                       */}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="small_boxes_slider">
                      <h4>Total TGC Staked</h4>
                      {/* <h4><span>The Grays</span> Staked</h4> */}
                      <h5>{totalStakedOverall} TGC</h5>
                      {/* <h5>{parseFloat(totalStakedOverall).toFixed(2)} TGC</h5> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="stakeSection padSection text-left" id="stakingSection">
        <div className="container">
          {/* <div className="grid_list_btn"><span className="active"><BsList /></span> <span><BsFillGrid3X3GapFill /></span></div> */}
          <div className="single_cart clearfix align-items-center">

            <Section maxStaking={1000} totalStaked={totalStaked} connectWallet={onOpen} updatePage={updatePage} minStaking={minStaking} lastStartTime={lastStartTime}>
              <div className="bottom_in">
                <div className="row">
                  <div className="col-sm-6 col_3 d-flex flex-column justify-content-center">
                    <p><a href="#" className="text-white">See Token Info  <FaShareSquare /></a></p>
                    <p><a href={`https://etherscan.io/address/${TokenContract.TOKEN_ADDRESS}`} className="text-white">View TGC Contract <FaShareSquare /></a></p>
                    <p><a href={`https://etherscan.io/address/${StakeContract.STAKE_ADDRESS}`} className="text-white">View Stake Contract <FaShareSquare /></a></p>
                    {/* <p><a href="#" className="text-white">See Token Info  <FaShareSquare /></a></p> */}
                  </div>
                  <div className="col-sm-6 col_3 equal-height">
                    <div className="inside-info-box border-0">
                      <div class="title">TGC Earned</div>
                      <div class="heightlight">{parseFloat(pendingReward).toFixed(2)}</div>
                    </div>
                    {/* <p className="grey_t">Earned</p>
                    <p className="t_orenge">0.0000 TGC</p>
                    <p>$0.000</p> */}
                  </div>
                  <div className="col-sm-6 col_3 equal-height">
                    <div className="inside-info-box">
                      {active ?
                        <>
                          <div class="title">Withdraw</div>
                          {totalStaked > 0 ?
                            <button class="btnbtn " onClick={unstake}>Withdraw</button>
                            :
                            <button class="btnbtn " disabled={true}>Withdraw</button>
                          }
                          {pendingReward > 0 ?
                            <button class="btnbtn" onClick={harvest}>Harvest</button>
                            :
                            <button class="btnbtn" disabled={true}>Harvest</button>
                          }
                        </>
                        :
                        <button class="btnbtn" onClick={onOpen}>Connect Wallet</button>
                      }
                    </div>
                    {/* <p className="grey_t">Start Staking</p>
                    <button className="orenge_btn">Connect Wallet</button> */}
                  </div>
                </div>
              </div>
            </Section>

          </div>
        </div>
      </section>


      {/* <section className="stakeSection padSection text-left">
        <div className="container">
          <div className="grid_list_btn"><span><BsList /></span> <span className="active"><BsFillGrid3X3GapFill /></span></div>
          <div className="single_cart clearfix align-items-center gridPanel">
            <div className="sn_sn sn_loop">
              <div className="top_box clearfix">
                <div className="width_hand">
                  <div className="logo"><img src="./logo192.png" alt="" className="img-responsive" /></div>
                  <div className="logo_name">
                    <h4 className="t_upper">EARN <span className="t_orenge">The Grays</span></h4>
                    <p>Stake The Grays</p>
                  </div>
                </div>
                <div className="width_hand">
                  <p className="grey_t ">Total Staked</p>
                  <p>6,000 TGC </p>
                </div>
                <div className="width_hand">
                  <p className="grey_t">Start Time</p>
                  <p>00:00:00</p>
                </div>
                <div className="width_hand">
                  <p className="grey_t">End Time</p>
                  <p>00:00:00</p>
                </div>
                <div className="width_hand">
                  <button className="last_btn">Hide <BiChevronDown /></button>
                </div>
              </div>
              <div className="bottom_box">
                <div className="bottom_in">
                  <div className="row">
                    <div className="col-sm-6 col_3">
                      <p><a href="#" className="t_orenge">See Token Info  <FaShareSquare /></a></p>
                      <p><a href="#" className="t_orenge">See Token Info  <FaShareSquare /></a></p>
                      <p><a href="#" className="t_orenge">See Token Info  <FaShareSquare /></a></p>
                    </div>
                    <div className="col-sm-6 col_3 pull-right">
                      <p className="grey_t">Earned</p>
                      <p className="t_orenge">0.0000 TGC</p>
                      <p>$0.000</p>
                    </div>
                    <div className="col-sm-6 col_3">
                      <p className="grey_t">Start Staking</p>
                      <button className="orenge_btn" onClick={onOpen}>Connect Wallet</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="sn_sn sn_loop">
              <div className="top_box clearfix">
                <div className="width_hand">
                  <div className="logo"><img src="./logo192.png" alt="" className="img-responsive" /></div>
                  <div className="logo_name">
                    <h4 className="t_upper">EARN <span className="t_orenge">The Grays</span></h4>
                    <p>Stake The Grays</p>
                  </div>
                </div>
                <div className="width_hand">
                  <p className="grey_t ">Total Staked</p>
                  <p>6,000 TGC </p>
                </div>
                <div className="width_hand">
                  <p className="grey_t">Start Time</p>
                  <p>00:00:00</p>
                </div>
                <div className="width_hand">
                  <p className="grey_t">End Time</p>
                  <p>00:00:00</p>
                </div>
                <div className="width_hand">
                  <button className="last_btn">Hide <BiChevronDown /></button>
                </div>
              </div>
              <div className="bottom_box">
                <div className="bottom_in">
                  <div className="row">
                    <div className="col-sm-6 col_3">
                      <p><a href="#" className="t_orenge">See Token Info  <FaShareSquare /></a></p>
                      <p><a href="#" className="t_orenge">See Token Info  <FaShareSquare /></a></p>
                      <p><a href="#" className="t_orenge">See Token Info  <FaShareSquare /></a></p>
                    </div>
                    <div className="col-sm-6 col_3 pull-right">
                      <p className="grey_t">Earned</p>
                      <p className="t_orenge">0.0000 TGC</p>
                      <p>$0.000</p>
                    </div>
                    <div className="col-sm-6 col_3">
                      <p className="grey_t">Start Staking</p>
                      <button className="orenge_btn" onClick={onOpen}>Connect Wallet</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <Footer />
      <SelectWalletModal isOpen={isOpen} closeModal={onClose} />
    </>
  );
};
export default Staking;